export default __webpack_public_path__ + "static/media/top3-bg.aa54aaa1.webp";